import { DeclarantDetails } from './DeclarantDetails';
import { Text } from '@nike/eds';
import  { Declarant } from './DeclarantDetails';
import getDeclarantsMock from "../../mocks/getDeclarants.mock.json";

const useDeclarantsApi = () => {
    return { data: { items: getDeclarantsMock.data?.getDeclarants?.items || [] }, isLoading: false };
}

export function Declarants()    {
    const { data, isLoading } = useDeclarantsApi();

    return (
        <div  className="eds-spacing--mb-24">
            <Text 
              className="eds-spacing--mb-8"
              font={'title-3'} 
              as={'h2'}>Declarants</Text>
            {isLoading && <Text>Loading declarants...</Text>}
            <div className="eds-flex eds-gap--16 ">
                {(data?.items || []).map((declarant: Declarant, index: number) => (
                    <DeclarantDetails key={index} declarant={declarant} />
                ))}
            </div>
        </div>
    );
}